module.exports = __webpack_public_path__ + "static/media/S3N12-2.0e151e51.svg";